import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './DiplomeForm.jsx'

export default createSubmit(name)